<template>
  <form class="sign-up-form">
    <div class="input-group-lg">
      <ValidationObserver
        tag="form"
        @submit.prevent="updateUser()"
        ref="userEdit"
      >
        <form-field
          :formFields="fields"
          :show="true"
          :model="data.updateUser"
          :id-prefix="idPrefix"
        />

        <div class="form-check col-12" v-if="allowConsentField">
          <input
            class="form-check-input" type="checkbox"
            v-model="data.updateUser.consent"
            :class="settings.consent.class"
            id="consent"
          >
          <label
            class="form-check-label"
            for="consent"
            v-html="settings.consent.html_content"
          />
        </div>

        <div class="form-check col-12" v-if="allowMarketingField">
          <input
            class="form-check-input" type="checkbox"
            v-model="data.updateUser.subscribed"
            :class="settings.marketing.class"
            id="user-subscribed"
          >
          <label class="form-check-label" for="user-subscribed">
            {{ settings.marketing.text }}
          </label>
        </div>

        <div class="captcha" v-if="showCaptcha && getCaptchaSiteKey">
          <validation-provider
            mode="lazy"
            :rules="!this.isVerified ? 'required' : ''"
            v-slot="{ errors }"
            ref="captcha"
            :custom-messages="customErrorMsg"
          >
            <vue-recaptcha
              :sitekey="getCaptchaSiteKey"
              @verify="verifyMethod"
              @expired="expiredMethod"
              @render="renderMethod"
              @error="errorMethod"
            />
            <div class="validation-error">
              <span class="w-100 text-black-50">{{ errors[0] }}</span>
            </div>
          </validation-provider>
        </div>

        <button
          type="submit"
          class="btn btn-lg d-flex ml-auto mr-auto mt-3 mb-3"
          :class="settings.attributes.button.class"
        >
          {{ settings.attributes.button.text }}
        </button>
      </ValidationObserver>
    </div>
  </form>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import FormField from './form/FormField.vue';
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  name: 'UserDetailFormFields',

  components: {
    FormField,
    ValidationObserver,
    VueRecaptcha
  },

  props: {
    isFulFillSync: Boolean,
    detailVerificationStep: Boolean,
    conditionalDisplay: Boolean,
  },

  data() {
    return {
      idPrefix: 'user-detail-page',
      showSuccessAlert: false,
      showErrorAlert: false,
      errorAlertMsg: '',
      sitesFields: [],
      data: {
        updateUser: {

        },
      },
      showRecaptcha: false,
      loadingTimeout: 30000, // 30 seconds
      isVerified: false,
      customErrorMsg: {}
    };
  },

  created() {
    this.customErrorMsg['required'] = 'Please verify you are human'
  },

  computed: {
    partner() {
      return this.$store.state.partners.currentPartner;
    },

    currentUser() {
      return this.$store.state.users.currentUser;
    },

    settings() {
      return this.partner.settings.sections.user_details_page;
    },

    fields() {
      return this.settings.fields;
    },

    allowConsentField() {
      return this.settings.consent && this.settings.consent?.show !== false &&
          this.settings.consent?.html_content;
    },

    allowMarketingField() {
      return this.settings.marketing && this.settings.marketing?.show !== false;
    },

    showCaptcha() {
      return this.settings?.captcha?.show === true;
    },

    getCaptchaSiteKey() {
      return this.settings?.captcha?.site_key;
    },

    programId() {
      return this.$route.query.program_id;
    },
  },

  methods: {
    updateUser() {
      let userdata = { program_id: this.programId , ...this.data.updateUser };

      if (this.allowConsentField) {
        this.$notify({
          group: 'notice-stay',
          type: 'error',
          text: 'You must agree to the terms and conditions to proceed.',
        });
      } else {
        this.$refs.userEdit.validate()
          .then((isValid) => {
            if (isValid) {
              this.$emit('loadingScreen', true);
              this.$store.dispatch('users/userDetailsPost', userdata)
                .then(() => {
                  this.$router.push({ path: `/applications/${this.currentUser.extra_info.project_id}/edit` });
                })
                .catch((errors) => {
                  let message = `Reason: ${errors.join(', ')}`;

                  console.log(message);
                  this.$notify({
                    group: 'notice-stay',
                    type: 'error',
                    text: `Unable to proceed. Please try again. ${message}`,
                  });
                }).finally(() => {
                  this.$emit('loadingScreen', false);
                });

            } else {
              this.$notify({
                group: 'notice-stay',
                type: 'error',
                text: 'Fill in all required fields.',
              });
            }
          });
      }
    },

    verifyMethod(response) {
      this.isVerified = true;
    },
    expiredMethod() {
      this.isVerified = false;
    },
    renderMethod() {
    },
    errorMethod(reason) {
    },
  },
};
</script>

<style lang="scss" scoped>
.captcha {
  text-align: -moz-center;
  text-align: -webkit-center;
}
</style>
